export default __webpack_public_path__ + "static/media/k_wdt_c_1_2.43da0080.mp3";